import { NgModule, Optional, SkipSelf } from '@angular/core';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { ICustomerGroupsFeature } from './customer-groups.feature.state';
import { customerGroupsReducer } from './customer-groups.reducer';
import { nameof } from '@symphony-solo/shared/utils/src';
import { CustomerGroupsEffects } from './customer-groups.effects';

@NgModule({
  imports: [
    StoreModule.forFeature(nameof<ICustomerGroupsFeature>('customerGroupsFeature'), customerGroupsReducer),
    EffectsModule.forFeature([CustomerGroupsEffects]),
  ],
})
export class CustomerGroupsStateModule {
  public constructor(
    @Optional()
    @SkipSelf()
    parentModule: CustomerGroupsStateModule
  ) {
    if (parentModule) {
      throw new Error('CustomerGroupStateModule is already loaded. Import it in the AppModule only');
    }
  }
}
